/* eslint-disable @typescript-eslint/no-explicit-any */
import { format, addDays } from 'date-fns';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const dateList = () => {
    const days = [
        {
            day: '1',
            name: 'Domingo',
        },
        {
            day: '2',
            name: 'Lunes',
        },
        {
            day: '3',
            name: 'Martes',
        },
        {
            day: '4',
            name: 'Miercoles',
        },
        {
            day: '5',
            name: 'Jueves',
        },
        {
            day: '6',
            name: 'Viernes',
        },
        {
            day: '7',
            name: 'Sabado',
        },
    ];
    const getDaysArray = (start, end) => {
        const arr: Array<any> = [];
        for (let i = 1, dt = start; dt <= end; dt.setDate(dt.getDate() + 1), i++) {
            const nameDay = days.find((d) => d.day === format(new Date(dt), 'c'));
            arr.push({
                id: i,
                day: nameDay?.name,
                date: format(new Date(dt), 'dd/MM'),
                year: format(new Date(dt), 'y'),
                all: format(new Date(dt), 'y/MM/dd'),
                dateFormat: format(new Date(dt), 'y-MM-dd'),
                active: format(new Date(dt), 'y/MM/dd') === format(new Date(), 'y/MM/dd'),
            });
        }
        return arr;
    };

    const daylist = getDaysArray(new Date(), new Date(addDays(new Date(), 15)));
    return daylist;
};
